export const refs = {
  mobileMenu: document.querySelector('.mobile-menu'),
  mobileMenuBtn: document.querySelector('.mobile-menu-btn'),
  closeMobileMenuBtn: document.querySelector('.close-btn'),
  exerciseList: document.querySelector('.exercise-list'),
  categoryContainer: document.querySelector('.category-container'),
  exerciseSearchForm: document.querySelector('.exercise-search-form'),
  backdrop: document.querySelector('.backdrop'),
  pagination: document.querySelector('.pagination'),
  favList: document.querySelector('.fav-list'),
  emptyWrapper: document.querySelector('.empty-wrapper'),
  quoteWrapper: document.querySelector('.quote-wrapper'),
  footerForm: document.querySelector('.footer-form'),
  filterList: document.querySelector('.filter-list'),
  scrollToTop: document.querySelector('.scroll-to-top'),
};
